module.exports = __webpack_public_path__ + "static/media/searchGray.4ba92263.svg";